(() => {
  const name = 'productBox';

  App.common = App.common || {};

  App.common[name] = (() => {
    const handleProductBoxAddToCart = (e, eData = null) => {
      if (eData === null) return;

      const $box = $(`[data-product-box][data-id="${eData.id}"]`);

      $box.attr('data-product-box-state', 'loading');
    };

    const handleProductBoxAddedToCart = (e, eData) => {
      const $box = $(`[data-product-box][data-id="${eData.id}"]`);

      $box.attr('data-product-box-state', 'loaded');
      setTimeout(() => {
        $box.attr('data-product-box-state', 'initial');
      }, 3000);
    };

    const bindEventListeners = () => {
      App.eventBus.on('product:add-to-cart', handleProductBoxAddToCart);
      App.eventBus.on('product:added-to-cart', handleProductBoxAddedToCart);
    };

    const init = () => {
      bindEventListeners();
    };

    return {
      init,
      bindEventListeners,
    };
  })();
})();
